import type { Person } from "@/FundExplorer/types";
import { hooks } from "@/styles/breakpoints";
import type { CitywireImages } from "@/types";
import Headshot from "../../../../components/Headshot";
import {
	managerHeadshotStyle,
	managerNameStyle,
	managerRatingStyle,
	managerText,
	managerTitleStyle,
	managerWrap,
	managersContainer,
	managersList,
	sectionTitle,
	wrap,
} from "./Managers.css";

const { useIsBelow } = hooks;

export default function Managers({
	managers,
	citywireRatings,
}: { managers: Person[]; citywireRatings?: CitywireImages["citywireRating"] }) {
	if (managers.length === 0) {
		return null;
	}
	return (
		<div className={wrap}>
			<h4 className={sectionTitle}>Fund managers</h4>
			<div className={managersContainer}>
				<div className={managersList}>
					{managers.map((manager) => (
						<Manager
							key={manager.id}
							manager={manager}
							citywireRating={
								citywireRatings?.[manager.citywireRating as string]
							}
						/>
					))}
				</div>
			</div>
		</div>
	);
}

function Manager({
	manager,
	citywireRating,
}: { manager: Person; citywireRating?: string }) {
	const isBelowL = useIsBelow("l");
	const managerName = `${manager.firstName} ${manager.lastName}`;
	const size = isBelowL ? 50 : 65;
	return (
		<div className={managerWrap}>
			<Headshot
				src={`${manager.__headshot}`}
				alt={managerName}
				className={managerHeadshotStyle}
				w={size}
				h={size}
			/>
			<div className={managerText}>
				<div className={managerNameStyle}>{managerName}</div>
				<div className={managerTitleStyle}>{`${manager.title}`}</div>
				{citywireRating && (
					<img
						src={`${process.env.SRP_ROOT}${citywireRating}`}
						alt={manager.citywireRating as string}
						className={managerRatingStyle}
					/>
				)}
			</div>
		</div>
	);
}
